import { useState,useEffect,useContext } from 'react'
import { useParams,useNavigate } from 'react-router-dom'
import { Alert, Button, Card, CardContent, Grid, Typography, Box, List, ListItem, ListItemText, Divider, CircularProgress, Tabs, Tab, ListItemAvatar, Avatar, Tooltip } from '@mui/material'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import SearchBox from '../../../components/SearchBox'
import { post } from '../../../utils/axios'
import { Context } from '../../../context/Context'
import { toast } from 'react-toastify'
import CommentIcon from '@mui/icons-material/Comment'

import './BusinessesServices.css'
import Slider from 'react-slick'

const PrevArrow = props => {
    const { onClick } = props
    return <div className="prev-arrow-btn" onClick={onClick}><i className="fal fa-chevron-left"></i></div>
}

const NextArrow = props => {
    const { onClick } = props
    return <div className="next-arrow-btn" onClick={onClick}><i className="fal fa-chevron-right"></i></div>
}

const BusinessesServices = () => {

    const navigate = useNavigate()
    const context = useContext(Context)

    const [currentTab,setCurrentTab] = useState(0)
    const { businessId } = useParams()
    const [business,setBusiness] = useState({})
    const [imageGallery,setImageGallery] = useState([])
    const [isLoading,setIsLoading] = useState(true)
    const [showLoading,setShowLoading] = useState(true)
    const [report,setReport] = useState([])
    const [open,setOpen] = useState(false)
    const [services,setServices] = useState([])
    const [subServices,setSubServices] = useState([])
    const [filteredSubServices,setFilteredSubServices] = useState([])
    const [searchText,setSearchText] = useState('')
    const [reorder,setReorder] = useState([])
    const [topServices,setTopServices] = useState([])
    const [openGallery,setOpenGallery] = useState(false)
    const [currentServiceId,setCurrentServiceId] = useState(0)
    const [comments,setComments] = useState([])
    const [approveOrder,setApproveOrder] = useState(false)

    const days = {
        1: 'شنبه',
        2: 'یکشنبه',
        3: 'دوشنبه',
        4: 'سه شنبه',
        5: 'چهارشنبه',
        6: 'پنج شنبه',
        7: 'جمعه'
    }

    const elementIsVisibleInViewport = elm => {
        if(elm != null && elm != undefined){
            var rect = elm.getBoundingClientRect()
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight) - 100
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
        }
    }

    useEffect(() => {
        const subServicePosteData = {
            businessId
        }
        post('MainService/GetAllBusinessServicesByBusinessId',subServicePosteData).then(({ data }) => {
            if(data.isSuccess){
                setServices(data.data)
                if(data.data.length)
                    setCurrentServiceId(data.data[0].id)
            }
        })
        post('SubService/GetTopSubServiceByBusinessId',{subServicePosteData}).then(({ data }) => {
            if(data.isSuccess){
                const topServicesId = []
                data.data.vResult.map(item => topServicesId.push(parseInt(item.subServiceId)))
                setTopServices(topServicesId)
            }
        })
        post('SubService/GetSubservicesByBusinessId',subServicePosteData).then(({ data }) => {
            if(data.isSuccess && data.data.length){
                setSubServices([...data.data.filter(item => item).sort((a,b) => a.serviceId - b.serviceId)])
                setFilteredSubServices([...data.data.filter(item => item).sort((a,b) => a.serviceId - b.serviceId)])
            }
        }).finally(() => {
            setIsLoading(false)
            const reorder = localStorage.getItem('reorder') ? [...JSON.parse(localStorage.getItem('reorder'))] : []
            localStorage.removeItem('reorder')
            setReorder(reorder)
        })
        post('Report/GetRankBaseQuestion',subServicePosteData).then(({ data }) => {
            if(data.isSuccess)
                setReport(data.data)
        })
        const businessPostedData = {
            id: businessId
        }
        post('Business/GetBusinessById',businessPostedData).then(({ data }) => {
            if(data.isSuccess){
                const isApproveOrder = data.data.paymentTypes.find(p => p.id == 5)
                setApproveOrder(isApproveOrder ? isApproveOrder : false)
                setBusiness(data.data)
                const images = []
                if(data.data.photo2)
                    images.push(data.data.photo2)
                if(data.data.photo3)
                    images.push(data.data.photo3)
                if(data.data.photo4)
                    images.push(data.data.photo4)
                if(data.data.photo5)
                    images.push(data.data.photo5)
                setImageGallery(images)
            }
        }).finally(() => {
            setShowLoading(false)
        })
        const commentsPostedData = {
            p_business: businessId
        }
        post('Report/getComments',commentsPostedData).then(({ data }) => {
            setComments(data.data || [])
        })
    },[])

    useEffect(() => {
        if(reorder.length && Object.keys(business).length){
            context.setGuildId(business.guildId)
            const services = []
            reorder.map(item => {
                let serviceItem = subServices.find(service => service.id == item)
                if(serviceItem)
                    services.push({
                        ...serviceItem,
                        cityId: business.cityId,
                        guildId: business.guildId
                    })
            })
            context.setBasket(services)
        }
    },[reorder,business])

    useEffect(() => {
        const filteredData = [...subServices]
        setFilteredSubServices(filteredData.filter(d => d.title.includes(searchText) || d.cityTitle?.includes(searchText) || d.provinceTitle?.includes(searchText)))
    },[searchText])

    useEffect(() => {
        const element = document.getElementById('businesses-services-parent')
        element.addEventListener('scroll',() => {
            let scrollTop = element.scrollTop
            services.map(service => {
                if(scrollTop == 0 && services.length)
                    setCurrentServiceId(services[0].id)
                if(elementIsVisibleInViewport(document.getElementById(`sub-service-parent-${service.id}`)) && currentServiceId != service.id){
                    const index = services.indexOf(service)
                    let scrollLeft = index * 90
                    document.getElementById('services-filter-box').scrollLeft = scrollLeft == 90 ? 0 : -scrollLeft
                    setCurrentServiceId(service.id)
                }
            })
            if(scrollTop > 140 && document.getElementById('all-business-container').offsetHeight > 550)
                document.getElementById('services-filter-box').classList.add('fixed-to-top')
            else
                document.getElementById('services-filter-box').classList.remove('fixed-to-top')
        },false)
    },[services])

    const scrollToService = serviceId => {
        const element = document.getElementById(`sub-service-parent-${serviceId}`)
        element.scrollIntoView({
            block: 'start'
        })
        setCurrentServiceId(serviceId)
    }

    const openMap = () => {
        window.open(`geo:${business.lat},${business.lang}`,'_blank')
    }

    const addToBasket = service => {
        context.setGuildId(business.guildId)
        service.cityId = business.cityId
        service.rule = business.rule
        if(business.guildId != 64 && context.basket.length){
            if(business.guildId == 204){
                if(context.basket.filter(item => item.businessId === service.businessId).length < 40)
                context.setBasket([...context.basket,{...service,guildId: business.guildId}])
                else
                    return toast.warning('با توجه به قوانین حداکثر چهل مورد در هر بار پرداخت می توانید خرید کنید')
            }else{
                const existing = context.basket.find(item => item.businessId === service.businessId)
                if(existing)
                    return toast.warning('با توجه به قوانین فقط یک مورد در هر بار پرداخت می توانید خرید کنید')
                else
                    return context.setBasket([{...service,guildId: business.guildId}])
            }
        }
        if(context.basket.length){
            const existing = context.basket.find(item => item.businessId === service.businessId)
            const deliveryType = context.basket[0].deliverType
            if(deliveryType != service.deliverType){
                toast.warning('سبد خرید شما به روزرسانی شد')
                context.setBasket([])
            }
            if(!existing)
                context.setBasket([{...service,guildId: business.guildId}])
            else
                context.setBasket([...context.basket,{...service,guildId: business.guildId}])
        }else
            context.setBasket([...context.basket,{...service,guildId: business.guildId}])
    }

    const removeFromBasket = service => {
        const oldBasket = [...context.basket]
        const index = oldBasket.findIndex(item => item.id == service.id)
        oldBasket.splice(index,1)
        context.setBasket(oldBasket)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        maxHeight: '80%',
        overflowY: 'auto',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    const gallerySettings = {
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    }

    return (
        <Grid sx={{position: 'relative'}}>
            <h3 className="others-page-title">{business.title || ''}</h3>
            <div id="businesses-services-parent" className="safe-area">
                <SearchBox searchText={searchText} setSearchText={setSearchText} placeholder="بر روی منو جستجو کنید" />
                <Grid container spacing={1}>
                    <Grid item xs={imageGallery.length ? 6 : 12}><Button fullWidth color="secondary" onClick={() => setOpen(true)} variant="contained" sx={{ py: 1.3,mb: 2 }}><i className="fal fa-circle-info" style={{ marginLeft: 5,fontSize: 17 }}></i>اطلاعات و نظرات</Button></Grid>
                    {imageGallery.length ? <Grid item xs={6}><Button fullWidth color="primary" onClick={() => setOpenGallery(true)} variant="contained" sx={{ py: 1.3,mb: 2 }}><i className="fal fa-image" style={{ marginLeft: 5,fontSize: 17 }}></i>گالری تصاویر</Button></Grid> : ''}
                </Grid>
                <Modal open={openGallery} onClose={() => setOpenGallery(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Fade in={openGallery}>
                        <Box sx={{...style,pb: 5}} id="gallery-modal">
                            <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>گالری تصاویر</Typography>
                            <i className="fal fa-x close-modal-btn" onClick={() => setOpenGallery(false)}></i>
                            <Slider {...gallerySettings}>
                                {imageGallery.map(image => <a className="ads-slider-item gallery-image-item" key={image}><img src={`https://petromah.sabinarya.com${image}`} /></a>)}
                            </Slider>
                        </Box>
                    </Fade>
                </Modal>
                <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Fade in={open}>
                        <Box sx={style}>
                            <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>{business.title}</Typography>
                            <i className="fal fa-x close-modal-btn" onClick={() => setOpen(false)}></i>
                            <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#888',mb: business.address || business.phone ? 0 : 3 }}>{business.guildTitle}</Typography>
                            {business.address ? <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#888',mt: 2 }}>آدرس: {(business.provinceTitle ? `${business.provinceTitle} - ` : '') + (business.cityTitle ? `${business.cityTitle} - ` : '') + business.address || '-'}</Typography> : ''}
                            {business.phone ? <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#888',mt: 0.5 }}>شماره تماس: <a dir="ltr" style={{color: '#888'}} href={`tel:${business.phone}`}>{business.phone}</a></Typography> : ''}
                            <div className="business-social-icons">
                                {business.instagram ? <a href={business.instagram} target="_blank"><i className="fab fa-instagram"></i></a> : ''}
                                {business.telegram ? <a href={business.telegram} target="_blank"><i className="fab fa-telegram"></i></a> : ''}
                                {business.website ? <a href={business.website} target="_blank"><i className="fal fa-globe-pointer"></i></a> : ''}
                            </div>
                            <Divider sx={{ mb: report.length ? 0 : 1 }} />
                            <Box sx={{ mb: 3 }}>
                                <Tabs value={currentTab} onChange={(e,currentTabIndex) => setCurrentTab(currentTabIndex)}>
                                    <Tab label="ساعات کاری" />
                                    <Tab label="امتیازات" />
                                    <Tab label="نظرات" />
                                </Tabs>
                            </Box>
                            {currentTab == 0 && <Box sx={{ mb: 2.5 }}>
                                {business.workingTimes && business.workingTimes.length ? <ul id="business-work-times">
                                    {business.workingTimes.map((work,index) => <li key={`work-${index}`}><span className="day-title">{days[work.dayId] || '-'} :</span><span className="day-time">{work.openTime} - {work.closeTime}</span></li>)}
                                </ul> : <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#535353',mb: 1.8 }}>ساعات کاری این کسب و کار ثبت نشده است</Typography>}
                            </Box>}
                            {currentTab == 1 && <Box sx={{ mb: 1.5 }}>
                                {report.length ? <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                    <span style={{fontSize: 13,marginBottom: '5px',display: 'block',textAlign: 'center'}}>تعداد شرکت کنندگان : {context.businessParticipator}</span>
                                    {report.map(question => (
                                        <ListItem key={question.q_title} disableGutters secondaryAction={<><span>{(question.avg_point / 20).toFixed(1)}</span><i className="fas fa-star" style={{ color: 'gold',marginRight: 5,opacity: `calc(2 * ${(question.avg_point / 20).toFixed(1) / 10})` }}></i></>} >
                                            <ListItemText primary={question.q_title.toString().replace(' ؟','').replace('؟','')} />
                                        </ListItem>
                                    ))}
                                </List> : <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#535353',mb: 1.8 }}>تا کنون امتیازی برای این کسب و کار ثبت نشده است</Typography>}
                            </Box>}
                            {currentTab == 2 && <Box sx={{ mt: -2,mb: 2.5 }}>
                                <List>
                                    {comments.length ? comments.map(comment => <>
                                        <ListItem id="comments-list" sx={{ px:0}}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <CommentIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={`${comment.firstName} میگه : `} primaryTypographyProps={{color: 'gray',fontSize: 14,marginBottom: 1}} secondary={<><p>{comment.suggestion}</p><span style={{color: 'gray',fontSize: 13,display: 'inline-block',marginTop: 10}}>تاریخ : {comment.suggestionDate?.split(' ')[0] || '-'}</span> <span style={{color: 'gray',fontSize: 13,display: 'inline-block',marginTop: 10}}>ساعت : {comment.suggestionDate?.split(' ')[1] || '-'}</span></>} secondaryTypographyProps={{color: '#000',fontSize: 15}} />
                                        </ListItem>
                                        <Divider variant="fullWidth" component="li" />
                                    </>) : <Typography variant="h6" component="h2" sx={{ fontSize: 14,color: '#535353',mb: 1.8 }}>تا کنون نظری برای این کسب و کار ثبت نشده است</Typography>}
                                </List>
                            </Box>}
                            {showLoading ? <CircularProgress size={30} sx={{ mb: 1.2,mx: 'auto',display: 'table' }} /> : ''}
                            {business.lat && business.lang ? <Button fullWidth color="primary" onClick={openMap} variant="contained" sx={{ py: 1.3 }}><i className="fal fa-location-dot" style={{ marginLeft: 5,fontSize: 17 }}></i>مشاهده نقشه / مسیریابی</Button> : ''}
                        </Box>
                    </Fade>
                </Modal>
                {services.length ? <div id="services-filter-box">
                    {services.map(service => <a key={service.id} className={currentServiceId == service.id ? 'active' : ''} id={`service-anker-${service.id}`} onClick={() => scrollToService(service.id)}>{service.title}</a>)}
                </div> : ''}
                {!filteredSubServices.length ? <Alert severity="info">سرویسی در این کسب و کار یافت نشد</Alert> : ''}
                <Box sx={{mb: 10}} id="all-business-container">
                    {searchText ? <>
                        {filteredSubServices.length ? filteredSubServices.map(service => <Grid key={service.id} item px={0.3}><Card sx={{ width: '100%',mb: 2.5,minHeight: '165px' }} className="service-item">
                            <CardContent className="service-content-area">
                                <img src={'/assets/img/default-logo.jpg'} className="service-logo" alt={''} />
                                <h3 className="service-item-title">{service.title}</h3>
                                <p className="service-item-content">{service.description}</p>
                                <span className="service-item-price">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(service.price)} ریال</span>
                                {context.basket.find(item => item.id === service.id) ?
                                (!!approveOrder && service.stockQuantity != 0 && <div className="services-buttons-container">
                                    <Tooltip title="افزودن به سبد خرید"><Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}><i className="fal fa-plus"></i></Button></Tooltip>
                                    <span>{context.basket.filter(item => item.id === service.id).length}</span>
                                    <Tooltip title="حذف از سبد خرید"><Button variant="contained" color="success" onClick={() => removeFromBasket(service)} sx={{ py:1,backgroundColor: '#efc3c3 !important',color: '#000' }}>{context.basket.filter(item => item.id === service.id).length > 1 ? <i className="fal fa-minus"></i> : <i className="fal fa-trash"></i>}</Button></Tooltip>
                                </div>)
                                :
                                (!!approveOrder && service.stockQuantity != 0 && <Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}>افزودن به سبد خرید</Button>)}
                                {!service.discountInclude ? <div className="delivery-types">
                                    {service.deliverType == 2 || service.deliverType == 3 ? <Tooltip title="ارسال با پیک"><i className="fal fa-moped"></i></Tooltip> : ''}
                                    {service.deliverType == 1 || service.deliverType == 3 ? <Tooltip title="تحویل حضوری"><i className="fal fa-house"></i></Tooltip> : ''}
                                </div> : <div className="delivery-types">
                                    <Typography sx={{ fontSize: '14px',mt: 1.5 }}>تعداد موجودی : {service.stockQuantity || 0}</Typography>
                                </div>}
                            </CardContent>
                        </Card></Grid>) : (isLoading ? <><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div></> : '')}
                        </> : filteredSubServices.length && topServices.length ? <div className="inline inline-popular">
                        <h2>پرطرفدار ها</h2>
                    </div> : ''}
                    {filteredSubServices.length ? filteredSubServices.map(service => {
                        if(topServices.includes(service.id))
                            return (<Grid key={service.id} item px={0.3}><Card sx={{ width: '100%',mb: 2.5,minHeight: '165px' }} className="service-item">
                                <CardContent className="service-content-area">
                                    <img src={'/assets/img/default-logo.jpg'} className="service-logo" alt={''} />
                                    <h3 className="service-item-title">{service.title}</h3>
                                    <p className="service-item-content">{service.description}</p>
                                    <span className="service-item-price">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(service.price)} ریال</span>
                                    {context.basket.find(item => item.id === service.id) ?
                                    (!!approveOrder && service.stockQuantity != 0 && <div className="services-buttons-container">
                                        <Tooltip title="افزودن به سبد خرید"><Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}><i className="fal fa-plus"></i></Button></Tooltip>
                                        <span>{context.basket.filter(item => item.id === service.id).length}</span>
                                        <Tooltip title="حذف از سبد خرید"><Button variant="contained" color="success" onClick={() => removeFromBasket(service)} sx={{ py:1,backgroundColor: '#efc3c3 !important',color: '#000' }}>{context.basket.filter(item => item.id === service.id).length > 1 ? <i className="fal fa-minus"></i> : <i className="fal fa-trash"></i>}</Button></Tooltip>
                                    </div>)
                                    :
                                    (!!approveOrder && service.stockQuantity != 0 && <Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}>افزودن به سبد خرید</Button>)}
                                    {!service.discountInclude ? <div className="delivery-types">
                                        {service.deliverType == 2 || service.deliverType == 3 ? <Tooltip title="ارسال با پیک"><i className="fal fa-moped"></i></Tooltip> : ''}
                                        {service.deliverType == 1 || service.deliverType == 3 ? <Tooltip title="تحویل حضوری"><i className="fal fa-house"></i></Tooltip> : ''}
                                    </div> : <div className="delivery-types">
                                        <Typography sx={{ fontSize: '14px',mt: 1.5 }}>تعداد موجودی : {service.stockQuantity || 0}</Typography>
                                    </div>}
                                </CardContent>
                            </Card></Grid>)
                    }) : ''}
                    {!searchText ? services.map(serviceItem => {
                        return <div className="sub-service-container-box" id={`sub-service-parent-${serviceItem.id}`} key={serviceItem.id}>
                            {subServices.filter(subService => subService.serviceId == serviceItem.id).length ? <div className="inline inline-popular sub-service-parent-title"><h2>{serviceItem.title}</h2></div> : ''}
                            {subServices.length ? subServices.filter(subService => subService.serviceId == serviceItem.id).map(service => <Grid key={service.id} item px={0.3}><Card sx={{ width: '100%',mb: 2.5,minHeight: '165px' }} className="service-item">
                                <CardContent className="service-content-area">
                                    <img src={'/assets/img/default-logo.jpg'} className="service-logo" alt={''} />
                                    <h3 className="service-item-title">{service.title}</h3>
                                    <p className="service-item-content">{service.description}</p>
                                    <span className="service-item-price">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(service.price)} ریال</span>
                                    {context.basket.find(item => item.id === service.id) ?
                                    (!!approveOrder && service.stockQuantity != 0 && <div className="services-buttons-container">
                                        <Tooltip title="افزودن به سبد خرید"><Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}><i className="fal fa-plus"></i></Button></Tooltip>
                                        <span>{context.basket.filter(item => item.id === service.id).length}</span>
                                        <Tooltip title="حذف از سبد خرید"><Button variant="contained" color="success" onClick={() => removeFromBasket(service)} sx={{ py:1,backgroundColor: '#efc3c3 !important',color: '#000' }}>{context.basket.filter(item => item.id === service.id).length > 1 ? <i className="fal fa-minus"></i> : <i className="fal fa-trash"></i>}</Button></Tooltip>
                                    </div>)
                                    :
                                    (!!approveOrder && service.stockQuantity != 0 && <Button variant="contained" color="success" onClick={() => addToBasket(service)} sx={{ py:1,backgroundColor: '#c3efc3 !important',color: '#000' }}>افزودن به سبد خرید</Button>)}
                                    {!service.discountInclude ? <div className="delivery-types">
                                        {service.deliverType == 2 || service.deliverType == 3 ? <Tooltip title="ارسال با پیک"><i className="fal fa-moped"></i></Tooltip> : ''}
                                        {service.deliverType == 1 || service.deliverType == 3 ? <Tooltip title="تحویل حضوری"><i className="fal fa-house"></i></Tooltip> : ''}
                                    </div> : <div className="delivery-types">
                                        <Typography sx={{ fontSize: '14px',mt: 1.5 }}>تعداد موجودی : {service.stockQuantity || 5}</Typography>
                                    </div>}
                                </CardContent>
                            </Card></Grid>) : (isLoading ? <><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div><div className="business-placeholder animate"></div></> : '')}
                        </div>
                    }) : ''}
                </Box>
                {context.basket.length ? <button id="show-basket-btn" onClick={() => navigate('/app/basket')}>ادامه خرید</button> : ''}
            </div>
        </Grid>
    )
}

export default BusinessesServices